import Icon from "../../../common/Icon";
import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/store";
import { pageFailure } from "../../../../reducers/uploadedBoard";
import {
  BoardMessage,
  MessageStatus,
  useCustomerMessage,
  useGetBoardMessages,
} from "../../../../utils/hooks/commonly-stored/messages";
import DropdownMenu, { MenuItem } from "../../../common/DropdownMenu";
import LoadingOverlay from "../../../LoadingOverlay";
import { useUpdateMessageStatus } from "../../../../utils/hooks/commonly-stored/uploaded-board/boardMessages";
import { Actions } from "./CustomerMessagesStyles";

export default function MessageActions({
  message,
  boardId,
}: {
  message: BoardMessage;
  boardId: string;
}) {
  const { refreshMessages } = useGetBoardMessages(boardId);
  const isAdminOrEngineer = useAppSelector(
    (state) => state.auth.isAdminOrEngineer,
  );

  const dispatch = useAppDispatch();
  const errorHandler = useCallback(() => {
    dispatch(pageFailure({ boardId: message.board_id }));
  }, [message.board_id, dispatch]);

  const { deleteMessage, saving } = useCustomerMessage(refreshMessages);
  const onRequestDeleteMessage = () => {
    deleteMessage(message.board_id, message.id);
  };

  const { updateMessageStatus, updatingMessageStatus } = useUpdateMessageStatus(
    message,
    errorHandler,
    refreshMessages,
  );

  const renderUpdateMessageStatusItem = () => {
    if (message.status == MessageStatus.READ) {
      return (
        <MenuItem onClick={() => updateMessageStatus(MessageStatus.UNREAD)}>
          Mark this message as unread
        </MenuItem>
      );
    } else if (message.status == MessageStatus.UNREAD) {
      return (
        <MenuItem onClick={() => updateMessageStatus(MessageStatus.READ)}>
          Mark this message as read
        </MenuItem>
      );
    }
  };

  if (isAdminOrEngineer) {
    return (
      <>
        <LoadingOverlay loading={saving} text={"Deleting..."} />
        <LoadingOverlay loading={updatingMessageStatus} text={"Updating..."} />
        <Actions>
          {isAdminOrEngineer && message.status == MessageStatus.READ && (
            <div title="Message is read">
              <Icon
                src={"/icons/check_green.svg"}
                alt={"options"}
                iconDimension={16}
              />
            </div>
          )}
          <DropdownMenu
            dropdownTrigger={
              <div title="Click for message options">
                <Icon
                  src={"/icons/three_dots_vertical_white.svg"}
                  alt={"options"}
                  iconDimension={16}
                />
              </div>
            }
          >
            <MenuItem onClick={onRequestDeleteMessage}>
              Delete this message
            </MenuItem>
            {renderUpdateMessageStatusItem()}
          </DropdownMenu>
        </Actions>
      </>
    );
  }
}
